<template>
  <div class="max-w-7xl mx-auto sm:px-2 lg:px-8 pb-12">
    <admin-chat-link class="py-2" />
    <live-session-page v-if="isLive" :session="live"></live-session-page>
    <div v-else>
      <div class="text-center mt-2">
        <CentralHeader
          title="Off Air"
          subtitle="Nothing is live right now. Here is what's up next"
        ></CentralHeader>
      </div>

      <session-schedule-block
        v-if="next"
        :session="next"
      ></session-schedule-block>
      <div v-if="complete.length > 0" class="mt-12">
        <div class="mt-2">
          <h2
            class="  text-2xl tracking-wider text-vectric  leading-10 font-bold text-white mt-4 sm:text-5xl sm:leading-none md:text-2xl uppercase"
          >
            Previous Sessions
          </h2>
          <div class="text-xl font-semibold tracking-wide leading-9 text-white">
            Click below to watch again or leave a comment or question
          </div>
          <div class="md:grid md:grid-cols-4 lg:grid-cols-4 gap-12 mt-10">
            <Card
              v-for="(prev, idx) in complete"
              :key="idx"
              class="shadow-lg border-white border-2 overflow-hidden"
            >
              <router-link :to="'/session/' + prev.slug.current">
                <previous-image :session="prev"></previous-image>
              </router-link>
            </Card>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showBanner" class="fixed bottom-3 inset-x-0 pb-2 sm:pb-5">
      <div class="max-w-screen-xl mx-auto px-2 sm:px-6 lg:px-8">
        <div class="p-2 rounded-lg bg-lightblue shadow-lg sm:p-3">
          <div class="flex items-center justify-between flex-wrap">
            <div class="w-0 flex-1 flex items-center">
              <span class="flex p-2 rounded-lg bg-lightblue">
                <svg
                  class="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  ></path>
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  ></path>
                </svg>
              </span>
              <p class="ml-3 font-medium text-white truncate">
                <span class="md:inline">
                  Thanks for watching '{{ showBanner.title }}'
                </span>
              </p>
            </div>
            <div
              class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto"
            >
              <div class="rounded-md shadow-sm">
                <router-link :to="'/session/' + showBanner.channelName">
                  <a
                    class="flex font-open-sans items-center justify-center px-4 py-2 border border-transparent
                          text-md leading-5 font-medium tracking-wide rounded-md text-indigo-600 bg-white hover:text-indigo-500 focus:outline-none focus:shadow-outline transition ease-in-out duration-150"
                  >
                    Watch Again
                  </a>
                </router-link>
              </div>
            </div>
            <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
              <button
                type="button"
                @click="showBanner = undefined"
                class="-mr-1 flex p-2 rounded-md hover:bg-indigo-500 focus:outline-none focus:bg-indigo-500 transition ease-in-out duration-150"
                aria-label="Dismiss"
              >
                <svg
                  class="h-6 w-6 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import {sanityAPIClient, sanityClient} from "../utils/sanity";
import SessionScheduleBlock from "../components/SessionScheduleBlock";
import LiveSessionPage from "../components/LiveSessionPage";
import AdminChatLink from "../components/AdminChatLink";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import PreviousImage from "../components/PreviousImage";
import _ from "underscore"
import Card from "../components/shared/Card.vue";
import CentralHeader from "../components/shared/CentralHeader.vue";
import {liveSessionRef} from "../utils/firebase";
import {setLiveSession} from "../utils/functions";


function objectIsEmpty(obj) {
  if (obj === null || obj === undefined) {
    return true
  }
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export default {
  name: "LiveFB",
  components: {CentralHeader, Card, PreviousImage, LiveSessionPage, SessionScheduleBlock, AdminChatLink},
  data() {
    return {
      live: null,
      liveID: null,
      isLive: false,
      next: null,
      nextID: null,
      complete: [],
      unsubscribe: null,
      showBanner: undefined
    }
  },
  created() {
    this.showBanner = undefined;
    this.fetchLive(false)
    // this.subscription = this.subscribe()
  },
  computed: {
    imageForPrevious(session) {
      console.log("get image");
      return sanityImageBuilder
          .image(session.previewImage)
          .width(400)
          .url();
    },
  },
  methods: {
    updateLive() {
      setLiveSession()
    },
    fetchLive(updateBanner) {
      this.unsubscribe =  liveSessionRef.onSnapshot(querySnapshot => {
          const res = querySnapshot.data();
          if (!objectIsEmpty(this.live) && this.isLive && res.complete && res.complete.length > 0) {
            const completed_ids = res.complete.map(x => x._id);
            const live_changed = completed_ids.includes(this.live._id);
            if (updateBanner && live_changed) {
              this.showBanner = this.live;
            }
          }

          if (!objectIsEmpty(res.live)) {

            if (!_.isEqual(res.live, this.live)) {
              this.live = res.live;
              this.next = res.next
              this.complete = res.complete
              this.isLive = true;
            }
          } else {
            if (!_.isEqual(res.live, this.live)) {
              this.isLive = false;
              this.next = res.next;
              this.live = res.live;
              this.complete = res.complete;
            }
          }
        })
    },
  },
  beforeDestroy() {
    console.log("before destroy")
    this.showBanner = undefined;
    if (this.unsubscribe) {
      console.log("unsubscribed")
      this.unsubscribe()
    }
  },
  mounted: function () {
  }
}
</script>
